angular.module('impactx.invoice').controller('InvoiceCreationCtrl', [
    '$scope',
    '$mdDialog',
    'themeFactory',
    'dataGen',
    'actionLabel',
    'withOrderRefLabel',
    'noOrderRefLabel',
    'lotLabel',
    'orderLabel',
    'forwardLabel',
    'abortLabel',
    'confirmLabel',
    'requiredLabel',
    'noSelectedItemMessage',
    'invoiceReceiverLabel',
    'orderTemplate',
    'creditNote',
    'preSetPoh',
    InvoiceCreationCtrl]);

function InvoiceCreationCtrl($scope, $mdDialog, themeFactory, dataGen, actionLabel, withOrderRefLabel, noOrderRefLabel, lotLabel, orderLabel,
                             forwardLabel, abortLabel, confirmLabel, requiredLabel, noSelectedItemMessage, invoiceReceiverLabel, orderTemplate,
                             creditNote, preSetPoh)
{
    var ctrl = this;
    $scope.canFinish = {};
    $scope.canFinish.value = false;
    $scope.selectedCreationType = {};
    $scope.selectedCreationType.value = 1;
    $scope.actionLabel = actionLabel;
    $scope.withOrderRefLabel = withOrderRefLabel;
    $scope.noOrderRefLabel = noOrderRefLabel;
    $scope.lotLabel = lotLabel;
    $scope.orderLabel = orderLabel;
    $scope.forwardLabel = forwardLabel;
    $scope.abortLabel = abortLabel;
    $scope.confirmLabel = confirmLabel;
    $scope.requiredLabel = requiredLabel;
    $scope.noSelectedItemMessage = noSelectedItemMessage;
    $scope.invoiceReceiverLabel = invoiceReceiverLabel;
    $scope.theme = themeFactory.getTheme();
    $scope.lotSupplier = {};
    $scope.lotSupplier.selected = null;
    $scope.orderCompany = {};
    $scope.orderCompany.selected = null;
    $scope.order = {};
    $scope.order.selected = null;
    $scope.wizardIndex = 0;
    $scope.showMust = true;
    $scope.uniqueContract = {};
    $scope.uniqueContract.value = true;
    $scope.foundNone = {};
    $scope.foundNone.value = false;
    $scope.orderTemplate = orderTemplate;
    $scope.noContractError = {};
    $scope.noContractError.value = "";
    $scope.finalMultipleContracts = {};
    $scope.finalMultipleContracts.value = false;
    $scope.lotReadOnly = {value: false};
    $scope.pohReadOnly = {value: false};

    if (preSetPoh)
    {
        $scope.selectedCreationType.value = 1;
        $scope.wizardIndex = 1;
        $scope.pohReadOnly.value = true;
        $scope.order.selected = preSetPoh;
    }

    if (creditNote)
    {
        $scope.wizardIndex = 1;
        $scope.selectedCreationType.value = 2;
    }
    this.cancel = function ()
    {
        $mdDialog.cancel();
    };
    this.forward = function ()
    {
        if ($scope.wizardIndex == 0)
        {
            $scope.wizardIndex++;
        }
        else if ($scope.wizardIndex == 1)
        {
            if (($scope.order.selected && $scope.order.selected.id > 0) || $scope.selectedCreationType.value == 2)
            {
                ctrl.finish();
            }
            else
            {
                $scope.wizardIndex++;
            }
        }
        else if ($scope.wizardIndex == 2)
        {
            ctrl.finish();
        }
    };
    this.finish = function ()
    {
        if (!$scope.uniqueContract.value)
        {
            var deliveryDate = $scope.orderTemplate.deliveryDateType.setId == 1 ? $scope.orderTemplate.deliveryDate.dateValue : $scope.orderTemplate.deliveryStartDate.dateValue;
            dataGen.getData({}, {lotSupplierId: $scope.lotSupplier.selected.id, orderComId: $scope.orderCompany.selected.id, deliveryDateValue: deliveryDate.getTime()}, "/invoice/uniquecontract").then(function(data) {
                $scope.uniqueContract.value = data.data.foundUnique;
                $scope.foundNone.value = data.data.foundNone;
                $scope.finalMultipleContracts.value = data.data.foundMultiple;
                if ($scope.uniqueContract.value)
                {
                    $mdDialog.hide({
                        lotSupplierId: $scope.lotSupplier.selected && $scope.lotSupplier.selected.id ? $scope.lotSupplier.selected.id : 0,
                        pohId: $scope.order.selected && $scope.order.selected.id ? $scope.order.selected.id : 0,
                        orderComId: $scope.orderCompany.selected && $scope.orderCompany.selected.id ? $scope.orderCompany.selected.id : 0,
                        withOrderRelation: $scope.selectedCreationType.value == 1,
                        deliveryDateValue: deliveryDate.getTime()
                    });
                }
                else
                {
                    $scope.noContractError.value = data.data.uniqueCheckErrors.warnings[0];
                }
            });
        }
        else
        {
            $mdDialog.hide({
                lotSupplierId: $scope.lotSupplier.selected && $scope.lotSupplier.selected.id ? $scope.lotSupplier.selected.id : 0,
                pohId: $scope.order.selected && $scope.order.selected.id ? $scope.order.selected.id : 0,
                orderComId: $scope.orderCompany.selected && $scope.orderCompany.selected.id ? $scope.orderCompany.selected.id : 0,
                withOrderRelation: $scope.selectedCreationType.value == 1
            });
        }
    };
    this.getLotSupplierEntries = function(searchText)
    {
        return dataGen.getData({}, {searchText: searchText}, "/invoice/lotsupplier", null, true).then(function(data) {
            return data.data.entries;
        });
    };
    this.getOrderEntries = function(searchText)
    {
        return dataGen.getData({}, {searchText: searchText, lotSupplierId: $scope.lotSupplier.selected ? $scope.lotSupplier.selected.id : 0,
            cscId: 0, excludePOHIds: []}, "/invoice/orders", null, true).then(function(data) {
                return data.data.entries;
        });
    };
    this.getOrderCompanyEntries = function(searchText)
    {
        return dataGen.getData({}, {searchText: searchText}, "/invoice/receivercompanies", null, true).then(function(data) {
            return data.data.entries;
        });
    };

    this.checkUniqueContractLotSupplier = function(selected)
    {
        if (selected && $scope.orderCompany.selected && $scope.orderCompany.selected.id && $scope.orderCompany.selected.id > 0)
        {
            dataGen.getData({}, {lotSupplierId: selected.id, orderComId: $scope.orderCompany.selected.id, deliveryDateValue: -1}, "/invoice/uniquecontract").then(function(data) {
                $scope.uniqueContract.value = data.data.foundUnique;
                $scope.foundNone.value = data.data.foundNone;
                if ($scope.foundNone.value)
                {
                    $scope.noContractError.value = data.data.uniqueCheckErrors.warnings[0];
                }
                else
                {
                    $scope.noContractError.value = "";
                }
                $scope.order.selected = {};
            });
        }
        else
        {
            $scope.uniqueContract.value = true;
            $scope.foundNone.value = false;
            $scope.noContractError.value = "";
            $scope.finalMultipleContracts.value = false;
        }
    };

    this.checkUniqueContractOrderCompany = function(selected)
    {
        if (selected && $scope.lotSupplier.selected && $scope.lotSupplier.selected.id && $scope.lotSupplier.selected.id > 0)
        {
            dataGen.getData({}, {lotSupplierId: $scope.lotSupplier.selected.id, orderComId: selected.id, deliveryDateValue: -1}, "/invoice/uniquecontract").then(function(data) {
                $scope.uniqueContract.value = data.data.foundUnique;
                $scope.foundNone.value = data.data.foundNone;
                if ($scope.foundNone.value)
                {
                    $scope.noContractError.value = data.data.uniqueCheckErrors.warnings[0];
                }
                else
                {
                    $scope.noContractError.value = "";
                }
            });
        }
        else
        {
            $scope.uniqueContract.value = true;
            $scope.foundNone.value = false;
            $scope.noContractError.value = "";
            $scope.finalMultipleContracts.value = false;
        }
    };
    $scope.$watch(function() {
        return  $scope.order.selected;
    }, function(newValue, oldValue) {
        if (newValue && newValue.id)
        {
            dataGen.getData({}, {pohId: newValue.id}, "/invoice/defaultdatafororder").then(function(data) {
                $scope.lotSupplier.selected = data.data.lotSupplier;
                $scope.orderCompany.selected = data.data.orderCompany;
                $scope.lotReadOnly.value = true;
            });
        }
        else
        {
            $scope.lotReadOnly.value = false;
        }
    });

    $scope.orderCompanyItemTemplate =
        "<div ix-autocomplete-selectable ng-class='{\"autocomplete-selectable\": entry.id > 0}' style='padding: 0'>" +
        "<div md-highlight-text=\"searchText\" md-highlight-flags=\"i\" class=\"autocomplete-invoice-company-name\">{{entry.value}}</div>" +
        "</div>";

}